import React from "react";
import { DoneButton } from "@deliverr/ui-facility";
import { useFreightArrivalHighPriorityPalletDoneButton } from "./useFreightArrivalHighPriorityPalletDoneButton";

export const FreightArrivalHighPriorityPalletDoneButton: React.FC = () => {
  const { onClick } = useFreightArrivalHighPriorityPalletDoneButton();
  return <DoneButton onClick={onClick} block />;
};
